import React, { Component, Fragment } from 'react'

import PropTypes from 'prop-types'
import { getUrlParameter } from '../../global/data/url.js'
import {
  formatDate,
  formatDateStandard,
} from '../../global/formatters/string-formatter.js'
import * as FundUtility from '../FundDetails/Helpers/FundUtility.js'
import TableUtility from '../FundDetails/Helpers/TableUtility.js'
import {
  HOLDING_TYPES,
  ETF_AND_INTERVAL_FIELDS,
} from '../FundDetails/Data/HoldingTypes.js'
import {
  MUTUAL_FUND,
  ETF_FUND,
  ETF_INDEX_FUND,
  CLOSED_END_FUND,
  VARIABLE_FUND,
  INTERVAL_FUND,
} from '../FundDetails/Helpers/FundTypes.js'
import {
  getETFTooltipContent,
  getTooltipContentByKey,
  getEtfHoldingsDisclousreData,
  getIntervalFundHoldingsDisclousreData,
} from '../Tooltip/tooltipUtil.js'
import DOMPurify from 'dompurify'

class FullHoldingsDetails extends Component {
  constructor(props) {
    super(props)

    this.state = {
      holdingTypes: {},
      EtfAndIntervalHoldingType: {
        sortOrder: 'asc',
        sortField: 'security',
        visible: true,
      },
      selectedInterval: 0,
      etfHoldingDisclosure: '',
      intervalFundHoldingDisclosure: '',
    }

    Object.keys(HOLDING_TYPES).forEach((holdingType) => {
      this.state.holdingTypes[holdingType] = {
        sortOrder: 'asc',
        sortField: 'secName',
        visible: true,
      }
    })
  }

  componentDidMount() {
    this.getHoldingsDisclousre()
  }

  async getHoldingsDisclousre() {
    if (this.checkFundGroup(ETF_FUND)) {
      const etfHoldingDisclosure = await getEtfHoldingsDisclousreData()

      this.setState({
        ...this.state,
        etfHoldingDisclosure,
      })
    } else if (this.checkFundGroup(INTERVAL_FUND)) {
      const intervalFundHoldingDisclosure =
        await getIntervalFundHoldingsDisclousreData()

      this.setState({
        ...this.state,
        intervalFundHoldingDisclosure,
      })
    }
  }

  checkFundGroup = (fundGroup) => {
    return this.props.fundGroup === fundGroup
  }

  hasETFHoldings() {
    if (!this.props.fullHoldingDetail) {
      return false
    }

    const { fundGroup } = this.props

    const { fullHoldings, holdings } = this.props.fullHoldingDetail

    return (
      fundGroup === ETF_FUND &&
      (fullHoldings?.length > 0 || holdings?.etfHoldings?.length > 0)
    ) // enforce boolean value.
  }

  hasIntervalFundHoldings() {
    if (!this.props.fullHoldingDetail) {
      return false
    }

    const { fundGroup } = this.props

    const { productHoldings, productFullHoldings } =
      this.props.fullHoldingDetail

    return (
      fundGroup === INTERVAL_FUND &&
      (productHoldings?.length > 0 || productFullHoldings?.length > 0)
    ) // enforce boolean value.
  }

  getWeightedAverageByDate(holdings, dateValue) {
    let result = {}
    let found = false

    holdings.forEach((holding) => {
      if (!found && holding.holdingsInterval === dateValue) {
        result = holding
        found = true
      }
    })

    if (!found) {
      result = {
        weightedAverageLifeMaturity: 'N/A',
        weightedAverageMaturity: 'N/A',
      }
    }

    return {
      weightedAverageLifeMaturity: result.weightedAverageLifeMaturity,
      weightedAverageMaturity: result.weightedAverageMaturity,
    }
  }

  getFilteredHoldings(list, dateValue, holdingType) {
    if (!dateValue) {
      return []
    }

    // there should only be one list per date.
    let item = list.find((holding) => {
      return holding.holdingsInterval === dateValue
    })

    if (
      this.checkFundGroup(MUTUAL_FUND) ||
      this.checkFundGroup(VARIABLE_FUND) ||
      this.checkFundGroup(CLOSED_END_FUND) ||
      this.checkFundGroup(INTERVAL_FUND)
    ) {
      if (item?.holdings) {
        return item.holdings.filter((row) => {
          return row.holdingType === holdingType
        })
      } else if (item?.productHolding) {
        return item.productHolding
      } else {
        return []
      }
    } else {
      if (!item) {
        return []
      } else {
        return item.etfHoldings
      }
    }
  }

  sortHoldings = (holdings, sorting) => {
    if (sorting) {
      const { sortOrder, sortField } = sorting

      if (sortOrder && sortField) {
        holdings = FundUtility.sortHoldings(holdings, sortOrder, sortField)
      }
    }

    return holdings
  }

  getMappedData(fullHoldingDetail, holdingType) {
    const { holdingsIntervals, fullHoldings } = fullHoldingDetail
    const dateValue = holdingsIntervals[this.state.selectedInterval]
    const holdingTypeData = this.state.holdingTypes[holdingType]
    const mappedData = HOLDING_TYPES[holdingType]

    mappedData.sorting = {
      sortOrder: holdingTypeData.sortOrder,
      sortField: holdingTypeData.sortField,
    }

    mappedData.visible = holdingTypeData.visible
    mappedData.holdings = this.getFilteredHoldings(
      fullHoldings,
      dateValue,
      holdingType
    )
    mappedData.holdings = this.sortHoldings(
      mappedData.holdings,
      mappedData.sorting
    )

    return mappedData
  }

  getMappedEtfData(fullHoldingDetail) {
    const { fullHoldings, holdings } = fullHoldingDetail

    const mappedData = {
      name: `etf`,
      title: 'ETF Holdings',
      holdingId: 'etfHoldings',
      collapseId: 'etfHoldingsCollapse',
      tableSelector: 'etf-holdings-table',
      fields: ETF_AND_INTERVAL_FIELDS,
    }

    mappedData.sorting = {
      sortOrder: this.state.EtfAndIntervalHoldingType.sortOrder,
      sortField: this.state.EtfAndIntervalHoldingType.sortField,
    }

    mappedData.visible = this.state.EtfAndIntervalHoldingType.visible

    if (fullHoldings) {
      // CHECK - Is this dead code?
      const { holdingsIntervals } = fullHoldingDetail
      const dateValue = holdingsIntervals[this.state.selectedInterval]

      mappedData.holdings = this.getFilteredHoldings(fullHoldings, dateValue)
    } else {
      mappedData.holdings = holdings.etfHoldings
    }

    // mappedData.holdings = holdings ? holdings : []
    mappedData.holdings = this.sortHoldings(
      mappedData.holdings,
      mappedData.sorting
    )

    return mappedData
  }

  getMappedIntervalData(fullHoldingDetail) {
    const { holdingsIntervals, productFullHoldings } = fullHoldingDetail
    const dateValue = holdingsIntervals[this.state.selectedInterval]

    const mappedData = {
      name: 'intervalFund',
      title: 'Interval Fund Holdings',
      holdingId: 'intervalFundHoldings',
      collapseId: 'intervalFundHoldingsCollapse',
      tableSelector: 'interval-fund-holdings-table',
      fields: ETF_AND_INTERVAL_FIELDS,
    }

    mappedData.sorting = {
      sortOrder: this.state.EtfAndIntervalHoldingType.sortOrder,
      sortField: this.state.EtfAndIntervalHoldingType.sortField,
    }

    mappedData.visible = this.state.EtfAndIntervalHoldingType.visible
    mappedData.holdings = this.getFilteredHoldings(
      productFullHoldings,
      dateValue
    )

    mappedData.holdings = this.sortHoldings(
      mappedData.holdings,
      mappedData.sorting
    )

    return mappedData
  }

  handleToggleCollapseClick(event) {
    let holdingType = event.currentTarget.dataset.type
    let holdingTypeData

    const isETFHolding = this.hasETFHoldings()
    const isIntervalHolding = this.hasIntervalFundHoldings()

    if (isETFHolding || isIntervalHolding) {
      holdingTypeData = this.state.EtfAndIntervalHoldingType

      this.setState((state) => {
        state.EtfAndIntervalHoldingType.visible = !holdingTypeData.visible

        return state
      })
    } else {
      holdingTypeData = this.state.holdingTypes[holdingType]

      this.setState((state) => {
        state.holdingTypes[holdingType].visible = !holdingTypeData.visible

        return state
      })
    }
  }

  handleSortClick(event) {
    let holdingType = event.currentTarget.dataset.type
    let sortField = event.currentTarget.dataset.sortField
    let sortOrder = event.currentTarget.dataset.sortOrder
    const isETFHolding = this.hasETFHoldings()
    const isIntervalHolding = this.hasIntervalFundHoldings()

    sortOrder = sortOrder === 'asc' ? 'desc' : 'asc'

    if (isETFHolding || isIntervalHolding) {
      this.setState((state) => {
        state.EtfAndIntervalHoldingType.sortOrder = sortOrder
        state.EtfAndIntervalHoldingType.sortField = sortField

        return state
      })
    } else {
      this.setState((state) => {
        state.holdingTypes[holdingType].sortOrder = sortOrder
        state.holdingTypes[holdingType].sortField = sortField

        return state
      })
    }
  }

  handleIntervalChange(event) {
    const { value } = event.target || {}
    let selectedInterval = 0

    const { fund } = this.props

    if (fund && fund.layoutID === '8') {
      const { fullHoldingDetail } = this.props
      selectedInterval = fullHoldingDetail.holdingsIntervals.indexOf(value)
    } else if (
      this.props.fullHoldingDetail.fullHoldings ||
      this.props.fullHoldingDetail.productFullHoldings
    ) {
      const { holdingsIntervals } = this.props.fullHoldingDetail
      selectedInterval = holdingsIntervals.indexOf(value)
    }

    this.setState({
      selectedInterval: selectedInterval,
    })
  }

  _renderDateDropdown() {
    const { holdingsIntervals } = this.props.fullHoldingDetail
    const { isFromDetails } = this.props

    return (
      <Fragment>
        {!isFromDetails && (
          <div className="u-sizeFit u-floatLeft u-paddingRight2gu u-paddingTop1gu">
            <span className="u-textSecondary">View holdings as of</span>
          </div>
        )}

        <div className="u-sizeFit u-floatRight">
          <div
            id="full-holdings-dropdown-container"
            className="Dropdown date-dropdown-template"
          >
            <select
              id="full-holdings-dropdown"
              className="Dropdown-menu"
              onChange={this.handleIntervalChange.bind(this)}
            >
              {holdingsIntervals &&
                holdingsIntervals.map((date, index) => {
                  const formattedDate = formatDate(date, true)
                  return (
                    <option key={formattedDate + index} value={date}>
                      {formattedDate}
                    </option>
                  )
                })}
            </select>
          </div>
        </div>
      </Fragment>
    )
  }

  _renderDisclosure() {
    const { fullHoldings, holdingsDetails } = this.props.fullHoldingDetail
    const isMutualFunds = this.checkFundGroup(MUTUAL_FUND)
    const isClosedEnd = this.checkFundGroup(CLOSED_END_FUND)
    const isIntervalFund = this.checkFundGroup(INTERVAL_FUND)
    const isRetailETF =
      this.checkFundGroup(ETF_FUND) || this.checkFundGroup(ETF_INDEX_FUND)
    const isVariableProducts = this.checkFundGroup(VARIABLE_FUND)
    let holdingDisclosure = ''
    const blockedCusips = ['19767X670', '19767X753']

    let isBlocked = blockedCusips.includes(this.props.cusip)

    if (fullHoldings) {
      holdingDisclosure = fullHoldings.holdingDisclosure
    } else if (holdingsDetails) {
      holdingDisclosure = holdingsDetails.disclosure
    }

    if (holdingDisclosure) {
      return (
        <div className="Disclaimer">
          <div
            className="Disclaimer-text"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(holdingDisclosure),
            }}
          />
        </div>
      )
    }

    return (
      <div className="u-sizeConstrained">
        <div className="Disclaimer">
          {(isMutualFunds || isClosedEnd) && (
            <Fragment>
              <p className="Disclaimer-text">
                Fund holdings are as of the date given, subject to change at any
                time and not a recommendation to buy or sell a security.
                Holdings shown as a percentage of fund net assets do not reflect
                derivative instruments. Holdings shown as a percentage of total
                notional exposure account for the total current value of a
                derivative contract&apos;s underlying asset. Notional value
                captures the exposure (leverage) associated with a derivative
                transaction and may exceed the dollar amount invested in the
                contract. For more information on this fund&apos;s full
                portfolio of investments, including investments in derivatives,
                please consult the fund&apos;s annual, semi-annual, first
                quarter and third quarter reports available on this website.
                Unlike the fund&apos;s Top Holdings, the fund&apos;s Full
                Holdings do not reflect accrued (earned but not yet received)
                income from underlying investments within (or part of) the
                fund&apos;s holding in the issuer.
              </p>
              <p className="Disclaimer-text">
                Non-money market fund holdings information is filed with the
                Securities and Exchange Commission (SEC) on Form N-PORT and can
                be obtained by visiting the SEC&apos;s website at{' '}
                <a
                  className="Link"
                  target="_blank"
                  href="http://www.sec.gov"
                  rel="noreferrer"
                >
                  www.sec.gov
                </a>
                . To access monthly holdings information filed with the SEC on
                Form N-MFP for money market funds on the SEC website,{' '}
                <a
                  className="Link"
                  target="_blank"
                  href="https://www.sec.gov/cgi-bin/browse-edgar?action=getcompany&CIK=0001352280&type=N-MFP&dateb=&count=40&scd=filings"
                  rel="noreferrer"
                >
                  click here
                </a>
                .
              </p>
              <p className="Disclaimer-text">
                Proprietary and non-proprietary fixed-income funds & ETFs are
                currently classified as Equity Holdings. For appropriate
                classifications, please consult the fund&apos;s annual,
                semi-annual, first quarter and third quarter reports available
                on this website.
              </p>
              {isBlocked && (
                <p className="Disclaimer-text">
                  <sup>*</sup>On May 25, 2022, the Office of Foreign Assets
                  Control (OFAC) license permitting the holding of the Sberbank
                  position expired, and the position is now considered blocked
                  property. As such, the security is restricted and has been
                  segregated on the Fund&apos;s appropriate books and records
                  and cannot be sold or transferred at this time. The security
                  is valued at fair value determined in good faith under
                  consistently applied procedures established by the Fund&apos;s
                  Board of Trustees.
                </p>
              )}
            </Fragment>
          )}

          {isVariableProducts && (
            <Fragment>
              <p className="Disclaimer-text">
                Fund holdings are as of the date given, subject to change at any
                time and not a recommendation to buy or sell a security.
                Holdings shown as a percentage of fund net assets do not reflect
                derivative instruments. Holdings shown as a percentage of total
                notional exposure account for the total current value of a
                derivative contract&apos;s underlying asset. Notional value
                captures the exposure (leverage) associated with a derivative
                transaction and may exceed the dollar amount invested in the
                contract. For more information on this fund&apos;s full
                portfolio of investments, including investments in derivatives,
                please consult the fund&apos;s annual, semi-annual, first
                quarter and third quarter reports available on this website.
                Unlike the fund&apos;s Top Holdings, the fund’s Full Holdings do
                not reflect accrued (earned but not yet received) income from
                underlying investments within (or part of) the fund’s holding in
                the issuer.
              </p>
              <p className="Disclaimer-text">
                Non-money market fund holdings information is filed with the
                Securities and Exchange Commission (SEC) on Form N-PORT and can
                be obtained by visiting the SEC&apos;s website at{' '}
                <a
                  className="Link"
                  target="_blank"
                  href="http://www.sec.gov"
                  rel="noreferrer"
                >
                  www.sec.gov
                </a>
                . To access monthly holdings information filed with the SEC on
                Form N-MFP for money market funds on the SEC website,{' '}
                <a
                  className="Link"
                  target="_blank"
                  href="https://www.sec.gov/cgi-bin/browse-edgar?action=getcompany&amp;CIK=0001352280&amp;type=N-MFP&amp;dateb=&amp;count=40&amp;scd=filings"
                  rel="noreferrer"
                >
                  click here
                </a>
                .
              </p>
              <p className="Disclaimer-text">
                Proprietary and non-proprietary fixed-income funds & ETFs are
                currently classified as Equity Holdings. For appropriate
                classifications, please consult the fund&apos;s annual,
                semi-annual, first quarter and third quarter reports available
                on this website.
              </p>
            </Fragment>
          )}

          {isRetailETF && (
            <Fragment>
              <div
                className="Disclaimer-text"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(this.state.etfHoldingDisclosure),
                }}
              />
            </Fragment>
          )}

          {isIntervalFund && (
            <Fragment>
              <div
                className="Disclaimer-text"
                dangerouslySetInnerHTML={{
                  __html: this.state.intervalFundHoldingDisclosure,
                }}
              />
            </Fragment>
          )}
        </div>
      </div>
    )
  }

  _renderTriConDisclosure() {
    return (
      <div className="u-sizeConstrained u-marginTop4gu">
        <p className="Disclaimer-text">
          Tri-Continental is managed by Columbia Management Investment Advisers,
          LLC. This material is distributed by Columbia Management Investment
          Distributors, Inc., member FINRA.
        </p>
      </div>
    )
  }

  _renderMoneyMarketTableRow(rowData, index) {
    const {
      amortizedCostValue,
      cusip,
      finalMaturity,
      fixedIncomeSecurityName,
      investmentCategory,
      maturity,
      par,
      percentOfNetAssets,
      rate,
    } = rowData
    return (
      <tr className="Table-row" key={cusip + index}>
        <td className="Table-cell">{fixedIncomeSecurityName}</td>
        <td className="Table-cell">{investmentCategory}</td>
        <td className="Table-cell u-textRight">{cusip}</td>
        <td className="Table-cell u-textRight">{par}</td>
        <td className="Table-cell">{formatDateStandard(maturity)}</td>
        <td className="Table-cell">{formatDateStandard(finalMaturity)}</td>
        <td className="Table-cell u-textRight">{rate}</td>
        <td className="Table-cell u-textRight">{amortizedCostValue}</td>
        <td className="Table-cell u-textRight">{percentOfNetAssets}</td>
      </tr>
    )
  }

  _renderMoneyMarketTable() {
    const { holdingsIntervals, fullHoldings } = this.props.fullHoldingDetail
    const dateValue = holdingsIntervals[this.state.selectedInterval]
    let moneyMarketHolding = []

    fullHoldings.forEach((holding) => {
      if (dateValue && holding.holdingsInterval === dateValue) {
        moneyMarketHolding = holding.holdings
      }
    })

    return (
      <table
        className="Table Table--reversed Table--striped"
        data-date-value="{dateValue}"
      >
        <thead className="Table-head">
          <tr className="Table-row">
            <th className="Table-header u-alignMiddle">Name of the issuer</th>
            <th className="Table-header u-alignMiddle">
              {' '}
              Rule 2a-7 Category of Investment{' '}
            </th>
            <th className="Table-header u-alignMiddle u-textRight">CUSIP </th>
            <th className="Table-header u-alignMiddle u-textRight">
              {' '}
              Principal Amount{' '}
            </th>
            <th className="Table-header u-alignMiddle">
              Effective Maturity (a){' '}
            </th>
            <th className="Table-header u-alignMiddle">Final Maturity (b) </th>
            <th className="Table-header u-alignMiddle u-textRight">
              Rate (%)(c){' '}
            </th>
            <th className="Table-header u-alignMiddle u-textRight">Value </th>
            <th className="Table-header u-alignMiddle u-textRight">
              % Net Assets{' '}
            </th>
          </tr>
        </thead>
        <tbody>
          {moneyMarketHolding.map((rowData, index) => {
            return this._renderMoneyMarketTableRow(rowData, index)
          })}
        </tbody>
      </table>
    )
  }

  _renderMoneyMarketDisclaimer() {
    return (
      <div className="Disclaimer">
        <div className="Disclaimer-text">
          <p>
            (a) The maturity date determined by taking into account the maturity
            shortening provisions of rule 2a-7(i) (i.e., the maturity data used
            to calculate the WAM under rule 2a-7(d)(1)(ii)).{' '}
          </p>
          <p>
            (b) The maturity date determined without reference to the exceptions
            in rule 2a-7(i) regarding interest rate readjustments (i.e., the
            maturity date used to calculate WAL under rule 2a-7(d)(1)(iii)).{' '}
          </p>
          <p>(c) Coupon or yield of security </p>
        </div>
      </div>
    )
  }

  _renderHoldingsTable(mappedData, holdingType) {
    const etfTooltipData = getETFTooltipContent()

    const tableData = {
      fields: mappedData.fields,
      keyId: 'full-holdings-' + holdingType,
      selector: mappedData.tableSelector,
      sorting: mappedData.sorting,
      sortClick: this.handleSortClick.bind(this),
      type: holdingType,
      values: mappedData.holdings,
    }

    const toolTips = [
      {
        heading:
          getTooltipContentByKey(etfTooltipData, 'Holdings Quantity')
            ?.heading || 'Quantity',
        content:
          getTooltipContentByKey(etfTooltipData, 'Holdings Quantity')
            ?.content || '',
        id: 'quantity',
        direction: 'Tooltip-right',
      },
    ]

    return <TableUtility data={tableData} toolTips={toolTips} />
  }

  _renderToggleCollapse(mappedData, holdingType) {
    const href = '#' + mappedData.collapseId
    const title = mappedData.title
    let styleCollapsed =
      'cti-table-header-collapse-link u-block u-textColorWhite u-paddingLeft3gu u-textSizeMsrp1 u-textBold'

    if (!mappedData.visible) {
      styleCollapsed = 'collapsed ' + styleCollapsed
    }

    return (
      <div className="cti-table-header-collapse u-posRelative u-sizeFull u-marginTop3gu">
        <a
          className={styleCollapsed}
          href={href}
          aria-expanded="false"
          aria-controls={mappedData.collapseId}
          onClick={this.handleToggleCollapseClick.bind(this)}
          data-type={holdingType}
        >
          {title}
        </a>
      </div>
    )
  }

  _renderHoldingsTableWrapper(holdingType) {
    const { fullHoldingDetail } = this.props

    if (!fullHoldingDetail) {
      return null
    }

    let mappedData
    if (holdingType === 'T') {
      mappedData = this.checkFundGroup(ETF_FUND)
        ? this.getMappedEtfData(fullHoldingDetail)
        : this.getMappedIntervalData(fullHoldingDetail)
    } else {
      mappedData = this.getMappedData(fullHoldingDetail, holdingType)
    }

    const hasHoldings = mappedData.holdings && mappedData.holdings.length > 0

    return (
      <div id={mappedData.holdingId} key={`div-holding-type-${holdingType}`}>
        {hasHoldings && this._renderToggleCollapse(mappedData, holdingType)}
        <div id={mappedData.collapseId} className="collapse in">
          <div className="cti-table-title-container">
            <div className="table-responsive">
              {hasHoldings &&
                mappedData.visible &&
                this._renderHoldingsTable(mappedData, holdingType)}
            </div>
          </div>
        </div>
      </div>
    )
  }

  _renderHoldingsContainer(fullHoldings) {
    const holdingTypes = Object.keys(HOLDING_TYPES)
    const styling = this.props.styling || {}

    return (
      <Fragment>
        <div className={styling.body}>
          <div className={styling.outer}>
            <div className={styling.inner}>
              {fullHoldings
                ? holdingTypes.map((holdingType) => {
                    return this._renderHoldingsTableWrapper(holdingType)
                  })
                : this._renderHoldingsTableWrapper('T')}
            </div>
          </div>
        </div>
      </Fragment>
    )
  }

  _renderWeightAverageTable() {
    const { holdingsIntervals, fullHoldings } = this.props.fullHoldingDetail
    const dateValue = holdingsIntervals[this.state.selectedInterval]
    let avgValue = {}

    if (dateValue) {
      avgValue = this.getWeightedAverageByDate(fullHoldings, dateValue)
    }

    return (
      <div className="List List--definition" data-date-value={dateValue}>
        <div className="List-item">
          <dt className="List-itemLabel">Weighted Average Maturity (WAM)</dt>
          <dd className="List-itemValue">
            {avgValue.weightedAverageMaturity} days
          </dd>
        </div>
        <div className="List-item">
          <dt className="List-itemLabel">Weighted Average Life (WAL)</dt>
          <dd className="List-itemValue">
            {avgValue.weightedAverageLifeMaturity} days
          </dd>
        </div>
      </div>
    )
  }

  _renderHeader() {
    return (
      <Fragment>
        <h3 className="u-sizeFit u-flexGrow1">Full Holdings (Unaudited)</h3>
        {this._renderDateDropdown()}
      </Fragment>
    )
  }

  _renderEtfHeader() {
    const { holdings } = this.props.fullHoldingDetail
    const cusip = getUrlParameter('cusip')
    const link = `/cmg.svc/exportETFholdings?fundGroupName=ETF&fileType=csv&cusip=${cusip}`

    return (
      <>
        <h3 className="u-sizeFit u-flexGrow1">
          All Holdings
          {holdings && (
            <span className="u-sm-block u-textSecondary u-textNormal u-textItalic">
              {' '}
              as of {formatDateStandard(holdings.etfHoldingAsOfDate)}
            </span>
          )}
        </h3>
        {holdings ? (
          <a className="u-sizeFit u-textSecondary" href={link}>
            Download all holdings (.csv)
          </a>
        ) : (
          this._renderDateDropdown()
        )}
      </>
    )
  }

  render() {
    if (!this.props.fullHoldingDetail) {
      return <div>No Full Holdings data present for this fund.</div>
    }

    const isMoneyMarket =
      this.props.fund &&
      (this.props.fund.layoutID === '8' || this.props.fund.layoutID === '19')

    const { fullHoldings } = this.props.fullHoldingDetail
    const isETFHolding = this.hasETFHoldings()
    const isIntervalHolding = this.hasIntervalFundHoldings()
    const styling = this.props.styling || {}

    const isTriCon = this.props.cusip === '895436103'

    return (
      <div id="full-holdings">
        <div className={styling.header}>
          <div className="Grid Grid--alignMiddle u-flex ">
            {(fullHoldings || isIntervalHolding) &&
              !isETFHolding &&
              this._renderHeader()}
            {isETFHolding && this._renderEtfHeader()}
          </div>
        </div>
        <div id="full-holdings-disclosure" className="u-marginTop4gu">
          {this._renderDisclosure()}
        </div>
        {isMoneyMarket && (
          <div className="Grid u-sizeConstrained u-marginBottom4gu u-marginTop4gu">
            <div
              id="full-holdings-weight-average-table"
              className="u-size4of12 u-md-size6of12 u-sm-sizeFull"
            >
              {this._renderWeightAverageTable()}
            </div>
          </div>
        )}
        <div className={styling.table}>
          <div id="full-holdings-table" className="u-overflowX">
            {isMoneyMarket && this._renderMoneyMarketTable()}
            {isMoneyMarket && this._renderMoneyMarketDisclaimer()}
            {this._renderHoldingsContainer(fullHoldings)}
          </div>
        </div>
        {isTriCon && this._renderTriConDisclosure()}
      </div>
    )
  }
}

FullHoldingsDetails.propTypes = {
  isShortTermFund: PropTypes.bool,
  isGovtMoneyMarketFund: PropTypes.bool,
  styling: PropTypes.object,
  holdingsDetails: PropTypes.object,
  fundGroup: PropTypes.string,
  cusip: PropTypes.string,
}

export default FullHoldingsDetails
